import { render, staticRenderFns } from "./UserSelectTile.vue?vue&type=template&id=2ff2e9f1&scoped=true&lang=pug&"
import script from "./UserSelectTile.vue?vue&type=script&lang=js&"
export * from "./UserSelectTile.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectTile.vue?vue&type=style&index=0&id=2ff2e9f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2e9f1",
  null
  
)

export default component.exports